import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[appSelectValueOnFocus]",
})
export class SelectValueOnFocusDirective {
  constructor(private elRef: ElementRef) {}
  @HostListener("focus") onFocus() {
    this.selectInputText();
  }
  private selectInputText() {
    this.elRef.nativeElement.select();
  }
}
